import React from 'react';
import { Navigate } from 'react-router';

const NoMatchRoute = () => {
  return <Navigate to="/" replace />;
};

export default NoMatchRoute;
